import { MoneyFormatOptions } from "@/types/productTypes";

export const formatMoney = (amount: number, options?: MoneyFormatOptions) => {
   const { currency, vatLabelIncluded } = options || {};
   const vatLabel = vatLabelIncluded ? "(plus VAT)" : "";
   const formattedMoney = new Intl.NumberFormat("no-NO", {
      style: "currency",
      currency: currency || "EUR",
   }).format(amount);

   return `${formattedMoney} ${vatLabel}`;
};
